import { NgModule } from '@angular/core';
import { GetContentPipe } from './get-content/get-content';
import {HttpClientModule} from "@angular/common/http";
import { ContentReplacePipe } from './content-replace/content-replace';
import { Nl2BrPipe } from './nl2-br/nl2-br';
import { Nl2LiPipe } from './nl2-li/nl2-li';
import {ItalizeBewegtPipe} from "./italize-bewegt/italize-bewegt";
import {Sort} from "./sort/sort";
@NgModule({
	declarations: [GetContentPipe,
    ContentReplacePipe,
    Nl2BrPipe,
    ItalizeBewegtPipe,
    Nl2LiPipe,
    Sort],
	imports: [ HttpClientModule ],
	exports: [GetContentPipe,
    ContentReplacePipe,
    ItalizeBewegtPipe,
    Nl2BrPipe,
    Nl2LiPipe,
    Sort]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts